module.exports = __webpack_public_path__ + "img/vu.0c83fc4.svg";